import * as React from "react";
import { Result } from "antd";

interface IProps {
  displayText: string;
}

const NotFound: React.FC<IProps> = (props) => {
  return (
    <Result
      status="404"
      title="404"
      subTitle={props.displayText}
      //extra={<Button type="primary">Back Home</Button>}
    />
  );
};

export default NotFound;
